export enum LocationProfileTierType {
    'Tier 1' = 1,
    'Tier 2',
    'Tier 3',
    'Tier 4',
    'Tier 5'
  }